import createWMTSSample from './wmts_sample.js';
import createWMSSample from './wms_sample.js';

import View from 'ol/View';
import Map from 'ol/Map';

import {defaults as defaultControls} from 'ol/control';
import {defaults as defaultInteractions} from 'ol/interaction';

const world = new View({
	projection: 'EPSG:4326',
	center: [4.702853947661122, 47.724485601287526],
	zoom: 0
});

const view = new View({	
	projection: 'EPSG:4326',
	center: [4.702853947661122, 47.724485601287526],
	zoom: 4
});

const createMap = (layer, target, readOnly, viewLevel) => {
	let mapControls = [];
	let mapInteractions = [];
	if( !readOnly ) {
		mapControls = defaultControls();
		mapInteractions = defaultInteractions();
	}
	
	const mapView = viewLevel === "world" ? world : view;
	
    return new Map({
        layers: [ layer ],
        target: target,
        controls: mapControls,
        interactions: mapInteractions,
        view: mapView
      });
}


const initExamples = () => {
	const data = document.querySelectorAll('.map');
	for(let i =  0; i < data.length; i++) {
		const map = data[i];
		const wmtsLayer = map.getAttribute('data-wmts-layer');
		const wmsLayer = map.getAttribute('data-wms-layer');
		const readOnly = map.hasAttribute('data-readonly');
		const view = map.getAttribute('data-map-view');

		let layer = null;
		
		if( wmtsLayer ) {
			const version = map.getAttribute('data-wmts-version');
			const levels = map.getAttribute('data-wmts-levels');

			layer = createWMTSSample(wmtsLayer, version, levels, view);
		} else if( wmsLayer ) {
			layer = createWMSSample(wmsLayer);
		}
		
		if( layer ) {
			createMap(layer, map, readOnly, view);
		}
	}
}

export default initExamples;

